import { Outlet, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuthStore } from '@/stores/auth-store'
import { useMaintenanceMode } from '@/hooks/use-maintenance-mode'
import { MaintenanceScreen } from './maintenance-screen'

/** Paths that stay reachable while maintenance is on so staff can sign in, reach admin, or read legal pages. */
function isMaintenanceExemptPath(pathname: string): boolean {
  return (
    pathname.startsWith('/auth') ||
    pathname.startsWith('/admin') ||
    pathname === '/terms' ||
    pathname === '/privacy'
  )
}

export function MaintenanceShell() {
  const { pathname } = useLocation()
  const role = useAuthStore((s) => s.role)
  const isStaff = role === 'admin' || role === 'moderator'
  const { data: maintenanceOn, isPending, isError } = useMaintenanceMode()

  if (isMaintenanceExemptPath(pathname) || isStaff) {
    return <Outlet />
  }

  if (isPending) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-hidden />
        <span className="sr-only">Checking status…</span>
      </div>
    )
  }

  // If the flag cannot be read, keep the app usable (same idea as other public settings reads).
  if (isError || !maintenanceOn) {
    return <Outlet />
  }

  return <MaintenanceScreen />
}
